// src/services/EmailService.ts

export interface IssuePayload {
    message: string;
    replyEmail: string;
}

export const EmailService = {
    async sendIssueReport(payload: IssuePayload) {
        // POST to your backend email endpoint
        await fetch("/api/home/sendissuereport", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload)
        });
    }
};
